import { render, staticRenderFns } from "./LiveOfferDealsComponent.vue?vue&type=template&id=4fc49b25&scoped=true&"
import script from "./LiveOfferDealsComponent.vue?vue&type=script&lang=ts&"
export * from "./LiveOfferDealsComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LiveOfferDealsComponent.vue?vue&type=style&index=0&id=4fc49b25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc49b25",
  null
  
)

export default component.exports